import { render, staticRenderFns } from "./LicenseBulkForm.vue?vue&type=template&id=126e8624&scoped=true&"
import script from "./LicenseBulkForm.vue?vue&type=script&lang=js&"
export * from "./LicenseBulkForm.vue?vue&type=script&lang=js&"
import style0 from "./LicenseBulkForm.vue?vue&type=style&index=0&id=126e8624&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "126e8624",
  null
  
)

export default component.exports